import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSimulatorTemplates = (getAuthHeaders, templates, setTemplates, formData, setFormData) => {
  const [showSaveTemplate, setShowSaveTemplate] = useState(false);
  const [newTemplateName, setNewTemplateName] = useState("");
  const [newTemplateDesc, setNewTemplateDesc] = useState("");

  const applyTemplate = (template) => {
    const fd = template.form_data || {};
    setFormData(prev => ({
      ...prev,
      ...fd,
      business_type: template.business_type || prev.business_type,
      regime_type: template.regime_type || prev.regime_type,
    }));
    toast.success(`Template "${template.name}" aplicado`);
  };

  const saveAsTemplate = async () => {
    if (!newTemplateName.trim()) {
      toast.error("Nome do template é obrigatório");
      return;
    }
    try {
      const payload = {
        name: newTemplateName.trim(),
        description: newTemplateDesc.trim(),
        business_type: formData.business_type,
        regime_type: formData.regime_type,
        form_data: { ...formData },
      };
      const res = await axios.post(`${API}/templates`, payload, { headers: getAuthHeaders() });
      setTemplates(prev => [...prev, res.data]);
      setShowSaveTemplate(false);
      setNewTemplateName("");
      setNewTemplateDesc("");
      toast.success("Template guardado");
    } catch (error) {
      toast.error("Erro ao guardar template");
    }
  };

  const deleteTemplate = async (templateId) => {
    try {
      await axios.delete(`${API}/templates/${templateId}`, { headers: getAuthHeaders() });
      setTemplates(prev => prev.filter(t => t.id !== templateId));
      toast.success("Template eliminado");
    } catch (error) {
      toast.error("Erro ao eliminar template");
    }
  };

  return {
    showSaveTemplate, setShowSaveTemplate,
    newTemplateName, setNewTemplateName,
    newTemplateDesc, setNewTemplateDesc,
    applyTemplate, saveAsTemplate, deleteTemplate,
  };
};
